import { Dispatch } from 'redux';
import { IApplicationState, AuthActionCreators } from '@nkr/store/index';
import { IGet } from '../authorization';

export const FileActionCreators = {
    downloadFile: (docType: number, lookupId: number): any => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + `/file/download/${docType}/${lookupId}`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getQuestionaireReport: (lookupId: number) => async (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/recipient/patient-intake/record/${lookupId}/screening/results`,
            responseType: 'blob'
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    uploadAboResults: (medicalRecordId: number, file: File) => async (dispatch: Dispatch<IApplicationState>) => {
        let formData = new FormData();
        formData.append('file', file);

        let options = {
            url: `${__API__}/file/pass-record/${medicalRecordId}/abo-results`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostFormData(options));
    },

    getFinancialAgreement: (centerId: number, donorId: number, recipientId: number) => async (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + `/file/${centerId}/financial-agreement-data?donorId=${donorId}&recipientId=${recipientId}`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getFormsAndChecklists: (donorId: number, recipientId: number) => async (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + `/swap/forms-and-checklists?donorId=${donorId}&recipientId=${recipientId}`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    downloadChecklist: (donorId: number) => async (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + `/donor/${donorId}/activation-checklist`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    }
}; 